import { createNamedContext } from '@utils';

type RehydrateApp = () => Promise<void>;

export const RehydrateAppContext = createNamedContext<RehydrateApp>(undefined, 'RehydrateApp.Context');